import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useDeleteAdminStaff = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('deleteAdminStaff', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: ['admin-staff'] });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync, isPending };
};

export default useDeleteAdminStaff;
